import { DASHBOARD_BUTTON_GROUP } from "../../util/constants";

export const tableFilterReducer = (state, action) => {
  switch (action.type) {
    case DASHBOARD_BUTTON_GROUP.RESUMELATER.TYPE:
      return {
        ...state,
        [DASHBOARD_BUTTON_GROUP.RESUMELATER.KEY]: !state[DASHBOARD_BUTTON_GROUP.RESUMELATER.KEY]
      };
    case DASHBOARD_BUTTON_GROUP.ASSIGNED.TYPE:
      return {
        ...state,
        [DASHBOARD_BUTTON_GROUP.ASSIGNED.KEY]: !state[DASHBOARD_BUTTON_GROUP.ASSIGNED.KEY]
      };
    default:
      return state;
  }
};